var map = {
	"./Path 85.png": 338,
	"./back-arrow-white.png": 339,
	"./back-arrow.png": 340,
	"./female-doctor.png": 108,
	"./ic-add-question.png": 146,
	"./ic-band-aid.png": 341,
	"./ic-check.png": 147,
	"./ic-close.png": 148,
	"./ic-close.svg": 342,
	"./ic-complete-native.png": 40,
	"./ic-conversation.png": 343,
	"./ic-export.png": 149,
	"./ic-import-question.png": 150,
	"./ic-incomplete-native.png": 67,
	"./ic-login.png": 109,
	"./ic-medical-result.png": 344,
	"./ic-next.png": 72,
	"./ic-patient-img.png": 345,
	"./ic-prev.png": 73,
	"./ic-refresh.png": 197,
	"./ic-search.png": 198,
	"./ic-waiting.png": 199,
	"./login-bg.jpg": 346,
	"./pending-symptom-img.png": 347
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 337;